import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import syntheticStockMoveService from "../../services/syntheticStockMoveService";

/**
 * @param {{ companyId: number, onSuccess?: () => void }} props
 */
const SyntheticOutboundCsvUploadModal = ({ companyId, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [failedRowNumbers, setFailedRowNumbers] = useState([]);
  const { openSnack } = useSnack();

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
      setFailedRowNumbers([]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      openSnack("Por favor seleccione un archivo CSV", "warning");
      return;
    }
    if (!companyId) {
      openSnack("Seleccione una compañía primero", "warning");
      return;
    }

    setUploading(true);
    setFailedRowNumbers([]);
    try {
      const result =
        await syntheticStockMoveService.uploadSyntheticOutboundsCsv(
          companyId,
          selectedFile
        );
      const succeeded =
        result?.succeededCount ?? result?.SucceededCount ?? 0;
      const failed =
        result?.failedRowNumbers ?? result?.FailedRowNumbers ?? [];

      openSnack(
        `${succeeded} fila${succeeded === 1 ? "" : "s"} cargada${succeeded === 1 ? "" : "s"} correctamente`,
        failed.length > 0 ? "warning" : "success"
      );
      setFailedRowNumbers(Array.isArray(failed) ? failed : []);
      setSelectedFile(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ p: 1, minWidth: 400 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      </Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Estructura del archivo CSV:
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Fecha de movimiento(DD-MM-YYYY), Clave de producto, Cantidad, Costo unitario (opcional).
      </Typography>

      <Box sx={{ mb: 2 }}>
        <input
          accept=".csv"
          style={{ display: "none" }}
          id="synthetic-outbound-csv-upload-input"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="synthetic-outbound-csv-upload-input">
          <Button
            variant="outlined"
            component="span"
            disabled={uploading}
            sx={{ mr: 2 }}
          >
            Seleccionar Archivo
          </Button>
        </label>
        {selectedFile && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            Archivo seleccionado: {selectedFile.name}
          </Typography>
        )}
      </Box>
      {failedRowNumbers.length > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Filas con error: {failedRowNumbers.join(", ")}
        </Alert>
      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
          startIcon={uploading ? <CircularProgress size={20} /> : null}
        >
          {uploading ? "Subiendo..." : "Subir CSV"}
        </Button>
      </Box>
    </Box>
  );
};

export default SyntheticOutboundCsvUploadModal;
